import React, { useEffect, useState } from 'react';
import { AiOutlineHome, AiOutlineMail } from 'react-icons/ai';
import { BiPhoneCall, BiInfoCircle } from 'react-icons/bi';
import axios from 'axios';
import { base_url, config } from '../utils/axiosConfig';

const Contact = () => {
  const [contact, setContact] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchContact = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(`${base_url}master/getcontact`, config);
        if (Array.isArray(res.data) && res.data.length > 0) {
          setContact(res.data[0]);
        }
        setIsError(false);
      } catch (err) {
        console.error('Failed to fetch contact:', err);
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchContact();
  }, []);

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center py-5 text-danger">
        <p>Failed to load contact information. Please try again later.</p>
      </div>
    );
  }

  return (
    <div className="contact-wrapper py-5 home-wrapper-2">
      <div className="container-xxl">
        <div className="row g-4">
          {/* Map */}
          <div className="col-12">
            <div className="rounded overflow-hidden shadow-sm border">
              <iframe
                src={contact.mapUrl || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d125766.1957731601!2d78.04042150095354!3d9.917826796702254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c582b1189633%3A0xdc955b7264f63933!2sMadurai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1728978350849!5m2!1sen!2sin"}
                width="100%"
                height="400"
                className="border-0"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps Location"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          <div className="col-12 col-md-6">
            <div className="bg-white p-4 rounded shadow-sm h-100">
              <h3 className="fw-semibold mb-3 text-dark">Send Us a Message</h3>
              <form className="d-flex flex-column gap-3">
                <input type="text" className="form-control rounded-2" placeholder="Your Name" />
                <input type="email" className="form-control rounded-2" placeholder="Your Email" />
                <input type="tel" className="form-control rounded-2" placeholder="Mobile Number" />
                <textarea className="form-control rounded-2" rows="4" placeholder="Your Message"></textarea>
                <button className="btn btn-primary w-100 py-2 fw-semibold">Send Message</button>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="col-12 col-md-6">
            <div className="bg-white p-4 rounded shadow-sm h-100">
              <h3 className="fw-semibold mb-3 text-dark">Get in Touch</h3>
              <ul className="list-unstyled m-0">
                <li className="mb-3 d-flex gap-3 align-items-start text-secondary">
                  <AiOutlineHome className="fs-5 mt-1" />
                  <address className="mb-0 small">{contact.addres || 'N/A'}</address>
                </li>
                <li className="mb-3 d-flex gap-3 align-items-center text-secondary">
                  <BiPhoneCall className="fs-5" />
                  <a href={`tel:${contact.number || ''}`} className="text-decoration-none small text-dark">
                    {contact.number || 'N/A'}
                  </a>
                </li>
                <li className="mb-3 d-flex gap-3 align-items-center text-secondary">
                  <AiOutlineMail className="fs-5" />
                  <a href={`mailto:${contact.email || ''}`} className="text-decoration-none small text-dark">
                    {contact.email || 'N/A'}
                  </a>
                </li>
                <li className="mb-0 d-flex gap-3 align-items-center text-secondary">
                  <BiInfoCircle className="fs-5" />
                  <p className="mb-0 small">{contact.time || 'N/A'}</p>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;
